import Image from 'next/image'

/**
 * Offizielles Stripe-Partner-Badge.
 *
 * Die beiden SVG-Dateien liegen unveraendert so im Repo, wie Stripe sie im
 * Partnerportal ausliefert. Die Co-Branding-Guidelines verbieten jede
 * Veraenderung: keine anderen Farben, kein Verzerren, kein zusaetzlicher
 * Effekt und kein neuer Text im Badge. Deshalb setzt diese Komponente nur die
 * Breite und leitet die Hoehe aus dem Originalverhaeltnis 287:72 ab, statt
 * width und height frei zu kombinieren. Aus demselben Grund gibt es hier
 * bewusst keinen Hover-Filter, wie ihn die Kundenlogos in der TrustBar haben.
 *
 * Variante: 'light' ist das weisse Badge fuer dunkle Flaechen (Standard auf
 * dieser Website), 'dark' das dunkelblaue fuer helle Karten.
 */

const BADGE_RATIO = 287 / 72

const BADGE_SRC = {
  light: '/images/logos/stripe-partner-badge-light.svg',
  dark: '/images/logos/stripe-partner-badge-dark.svg'
} as const

type StripePartnerBadgeProps = {
  variant?: keyof typeof BADGE_SRC
  /** Darstellungsbreite in Pixeln, die Hoehe folgt dem Originalverhaeltnis. */
  width?: number
  className?: string
  priority?: boolean
}

const StripePartnerBadge = ({ variant = 'light', width = 180, className, priority = false }: StripePartnerBadgeProps) => (
  <Image
    src={BADGE_SRC[variant]}
    // Der Alternativtext gibt exakt den Badge-Text wieder, er wird nicht uebersetzt.
    alt="Stripe Partner"
    width={width}
    height={Math.round(width / BADGE_RATIO)}
    className={className}
    priority={priority}
  />
)

export default StripePartnerBadge
